// -----------------------------------------------------------------------------
// <copyright file="date.pipe.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'vsdate',
  standalone: false,
})
export class VsDatePipe implements PipeTransform {
  public transform(value: any, args: any, convertToLocalTime?: boolean): any {
    if (value) {
      let dateFormt = 'DD MMMM YYYY, h:mm A';
      if (args === 'DD-MM-YYYY') {
        dateFormt = 'DD MMMM YYYY';
      }
      if (args === 'DD-M-YYYY') {
        dateFormt = 'DD MMM YYYY';
      }
      if (args === 'M-DD-YYYY') {
        dateFormt = 'MMM DD, YYYY';
      }
      if (args === 'MM/DD/YYYY') {
        dateFormt = 'MM/DD/YYYY';
      }
      if (args === 'YYYY-MM-DD') {
        dateFormt = 'YYYY-MM-DD';
      }
      if (args === 'DD MMM YYYY, h:mm A') {
        dateFormt = args;
      }

      if (args === 'h:mm A') {
        dateFormt = args;
      }
      if (convertToLocalTime) {
        // Convert UTC to local time zone
        return moment.utc(value).local().format(dateFormt);
      }
      return moment(value).format(dateFormt);
    } else {
      return value;
    }
  }
}
